import { cloneElement, isValidElement, ReactElement, ButtonHTMLAttributes } from 'react';
import { useAuth, Permission } from '../context/AuthContext';
import { Tooltip } from './Tooltip';

interface ProtectedComponentProps {
  children: ReactElement<ButtonHTMLAttributes<HTMLButtonElement>>;
  requiredPermission: Permission;
  showDisabled?: boolean;
  disabledTooltip?: string;
}

const ProtectedComponent = ({ 
  children, 
  requiredPermission,
  showDisabled = true,
  disabledTooltip = 'Insufficient permissions'
}: ProtectedComponentProps) => {
  const { hasPermission } = useAuth();
  const hasAccess = hasPermission(requiredPermission);

  if (!hasAccess && showDisabled && isValidElement(children)) {
    const disabledButton = cloneElement(children, {
      ...children.props,
      disabled: true,
      'aria-disabled': true,
      className: `${children.props.className || ''} opacity-50 cursor-not-allowed`,
    });

    return (
      <Tooltip content={disabledTooltip}>
        {disabledButton}
      </Tooltip>
    );
  }

  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedComponent;